import React from 'react';
import { connect } from 'react-redux';
import { Row, Card, Button, FormGroup } from 'react-bootstrap';
import { FormValidator } from '../../helpers/form-validator';
import { getUserId } from '../../helpers/session';
import { Unit } from '../../helpers/unit';
import { CardContainer } from '../widgets/CardContainer';
import { Icon, Form, TitleIcon, Heading5 } from '../widgets';
import { EQUIPMENT_HANDLING, EQUIPMENT_IMPLEMENT, EQUIPMENT_SCALE, EQUIPMENT_REMOTECONTROL } from '../../constants';
import {
    getEquipmentConfig, getCategoryTypeList, getSubCategoryTypeList,
    getEquipmentModelList, getEquipmentFields, createEquipment, equipmentInfo,
    getEquipmentInfo, getEquipmentMakeList, editEquipment, equipmentModelList, getEquipmentList, getEquipmentVendorList
} from '../../actions/equipment';
import { getOEMMakeList } from "../../actions/oem";
import { getEquipmentNameList } from '../../actions/eg-kanban';
import { getRateScheduleLists } from '../../actions/rate-schedule';
import EquipmentTextBox from './EquipmentText';
import EquipmentDropdown from './EquipmentDropdown';
import EquipmentInteger from './EquipmentInt';
import EquipmentDate from './EquipmentDate';
import EquipmentBoolean from './EquipmentBoolean';

class EquipmentForm extends React.Component {
    constructor(props) {
        super(props);
        this.unit = Unit.getInstance();
        this.validator = new FormValidator([]);

        this.state = {
            validation: this.validator.valid(),
            equipmentId: null,
            equipmentTypeId: 0,
            categoryId: -1,
            subcategoryId: -1,
            planTypeId: 0,
            custom: {
                make_id: '',
                model_id: '',
                vendor_id: ''
            },
            fields: {},
            oem_monitor: {
                "name": "OEM Access",
                "key_name": "oem_monitor",
                "input_type": "list",
                "required": false,
                "values": [
                    {
                        "value": "Allow",
                        "label": "Allow"
                    },
                    {
                        "value": "Disallow",
                        "label": "Disallow"
                    }
                ],
                "default_value": "Disallow"
            },
            makeList: [],
            oemMakeId: [],
        };

        this.handleEquipmentType = this.handleEquipmentType.bind(this);
        this.handleCategory = this.handleCategory.bind(this);
        this.handleSubcategory = this.handleSubcategory.bind(this);
        this.handlePlanType = this.handlePlanType.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleChecked = this.handleChecked.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.saveEquipment = this.saveEquipment.bind(this);
        this.getStateValues = this.getStateValues.bind(this);
        this.bindValues = this.bindValues.bind(this);
        this.getFieldsProps = this.getFieldsProps.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onBlurMake = this.onBlurMake.bind(this);

        this.submitted = false;
        this.isEditMode = false;
    }

    componentDidMount() {
        this.isEditMode = this.props.equipmentId;
        this.isEditMode && this.setState({ equipmentId: this.props.equipmentId });

        this.props.dispatch(getEquipmentMakeList());
        this.props.dispatch(getOEMMakeList())
        this.props.dispatch(getEquipmentVendorList());
        if (this.props.farmId) this.props.dispatch(getRateScheduleLists(this.props.farmId));
        this.props.dispatch(getEquipmentConfig(() => {
            if (this.isEditMode) this.props.dispatch(getEquipmentInfo({ equipment_uuid: this.props.equipmentId }));
        }));

        this.setState({ makeList: this.props.makeList });
    }

    componentDidUpdate(prevProps) {
        if (this.props.categoryTypeList && this.props.equipmentInfo
            && prevProps.equipmentInfo !== this.props.equipmentInfo
            && Object.keys(this.props.equipmentInfo).length > 0) this.bindValues();

        if (prevProps && this.props && (prevProps.makeList !== this.props.makeList)) {
            this.setState({ makeList: this.props.makeList ? this.props.makeList.map(e => e.equipment_make_name) : [] });
            this.setState({ oemMakeId: this.props.makeList ? this.props.makeList.map(e => e.equipment_make_id) : [] });
        }
    }

    bindValues() {
        this.submitted = false;
        const r = this.props.equipmentInfo;

        if (r.specification && r.specification.hasOwnProperty('capacity')) {
            const capacity = r.specification.capacity ? r.specification.capacity : 0;
            r.specification['capacity'] = this.unit.toWeight(capacity, 2);
        }
        if (r.specification && r.specification.hasOwnProperty('light_weight')) {
            const lightWeight = r.specification.light_weight ? r.specification.light_weight : 0;
            r.specification['light_weight'] = this.unit.toWeight(lightWeight, 2);
        }

        const params = {
            equipmentTypeId: r.equipment_type_id,
            categoryId: r.equipment_category_id,
            subcategoryId: r.equipment_subcategory_id,
            planTypeId: r.plan_type_id,
            custom: {
                make_id: r.equipment_make_name,
                model_id: r.equipment_model_name,
                vendor_id: r.equipment_vendor_name
            },
            fields: {
                name: r.name,
                make_id: r.equipment_make_id,
                model_id: r.equipment_model_id,
                vendor_id: r.equipment_vendor_id,
                rate_schedule_uuid: r.rate_schedule_uuid,
                serial_number: r.serial_number,
                year: r.year,
                is_tare_truck: r.is_tare_truck,
                oem_monitor: r.oem_monitor,
                is_own_bed: r.is_own_bed,
                ...r.specification
            }
        };

        this.setState(params);
        this.props.dispatch(getCategoryTypeList(r.equipment_type_id, r.plan_type_id));
        this.props.dispatch(getSubCategoryTypeList(r.equipment_type_id, r.equipment_category_id));
        this.props.dispatch(getEquipmentFields({ subcategoryId: r.equipment_subcategory_id }));
        if (r.equipment_make_id > 0) this.props.dispatch(getEquipmentModelList(r.equipment_make_id));
    }

    handleChange(event) {
        const { name, value, type } = event.target;
        const fields = { ...this.state.fields, [name]: ((type === 'number' || type === 'int') && (value === 0 || typeof value === 'string')) ? value : value };
        this.setState({ fields });
    }

    handleChecked(event) {
        const { name, checked } = event.target;
        const fields = { ...this.state.fields, [name]: checked };
        this.setState({ fields });
    }

    handleSelect(selectedOption, name) {
        const custom = { ...this.state.custom };
        const { value, label } = selectedOption ? selectedOption : { value: 0, label: '' };
        const fields = { ...this.state.fields, [name]: value };
        if (name === 'make_id') {
            fields.model_id = "";
            custom.model_id = "";
            this.props.dispatch(getEquipmentModelList(value));
        }
        if (this.state.custom.hasOwnProperty(name)) custom[name] = label;
        this.setState({ fields, custom });
    }

    handleEquipmentType(selectedOption) {
        const equipmentTypeId = selectedOption ? parseInt(selectedOption.value) : 0;
        this.setState({ equipmentTypeId, planTypeId: 0, categoryId: 0, subcategoryId: 0 });
        this.props.dispatch(getCategoryTypeList(equipmentTypeId));
    }

    handlePlanType(selectedOption) {
        const planTypeId = selectedOption ? parseInt(selectedOption.value) : 0;
        const { equipmentTypeId } = this.state;
        this.setState({ planTypeId });
        this.props.dispatch(getCategoryTypeList(equipmentTypeId, planTypeId));
    }

    handleCategory(selectedOption) {
        const categoryId = selectedOption ? parseInt(selectedOption.value) : 0;
        this.setState({ categoryId, subcategoryId: 0 });
        this.props.dispatch(getSubCategoryTypeList(this.state.equipmentTypeId, categoryId));
    }

    handleSubcategory(selectedOption) {
        const subcategoryId = selectedOption ? parseInt(selectedOption.value) : 0;
        this.setState({ subcategoryId });
        this.props.dispatch(getEquipmentFields({ subcategoryId }));
    }

    getStateValues() {
        return { ...this.state, ...this.state.fields, ...this.state.custom, fields: null };
    }

    saveEquipment(fieldsData) {
        const validateData = [];
        let inputFields = {};

        fieldsData.forEach(element => {
            if (element.required) {
                validateData.push({
                    field: element.key_name,
                    method: 'isEmpty',
                    validWhen: false,
                    message: element.name + ' is required'
                });
            }

            inputFields[element.key_name] = this.state.fields.hasOwnProperty(element.key_name) ?
                this.state.fields[element.key_name] : element.default_value;
        }, this);

        const isValidCategoryId = (this.state.categoryId === 0 || this.state.categoryId === -1);
        if (isValidCategoryId) {
            validateData.push({
                field: "categoryId",
                method: 'isEmpty',
                validWhen: true,
                message: 'category is required'
            })
        }

        let fields = { ...this.state.fields, ...inputFields }

        this.validator.setValidation(validateData);
        const validation = this.validator.validate({ ...this.state, ...fields, ...this.state.custom, fields: null });
        this.setState({ validation, fields });
        this.submitted = true;

        if (validation.isValid) {
            const s = this.state;
            const farmId = this.props.farmId;
            const spec = { ...s.fields };
            let isTareTruck = false;
            let rateId = null;
            let isOwmBed = false;

            const success = () => {
                if (this.props.isModalType) {
                    const equipmentType = [EQUIPMENT_IMPLEMENT, EQUIPMENT_HANDLING, EQUIPMENT_SCALE, EQUIPMENT_REMOTECONTROL].includes(s.equipmentTypeId) ? "implement" : "vehicle";
                    this.props.dispatch(getEquipmentNameList({ farmId, equipmentType }));
                }
                this.props.dispatch(getEquipmentList({ farmId: this.props.farmId }));
                this.props.onHide()
            }

            if (spec.hasOwnProperty('name')) delete spec.name;
            if (spec.hasOwnProperty('make_id')) delete spec.make_id;
            if (spec.hasOwnProperty('model_id')) delete spec.model_id;
            if (spec.hasOwnProperty('vendor_id')) delete spec.vendor_id;
            if (spec.hasOwnProperty('year')) delete spec.year;
            if (spec.hasOwnProperty('serial_number')) delete spec.serial_number;
            if (spec.hasOwnProperty('oem_monitor')) delete spec.oem_monitor;
            if (spec.hasOwnProperty('is_tare_truck')) {
                isTareTruck = spec.is_tare_truck;
                delete spec.is_tare_truck;
            }
            if (spec.hasOwnProperty('rate_schedule_uuid')) {
                rateId = spec.rate_schedule_uuid;
                delete spec.rate_schedule_uuid;
            }

            if (spec.hasOwnProperty('capacity')) {
                const capacity = spec.capacity ? spec.capacity : 0;
                spec['capacity'] = this.unit.fromWeight(capacity);
            }
            if (spec.hasOwnProperty('light_weight')) {
                const lightWeight = spec.light_weight ? spec.light_weight : 0;
                spec['light_weight'] = this.unit.fromWeight(lightWeight);
            }
            if (spec.hasOwnProperty('is_own_bed')) {
                isOwmBed = spec.is_own_bed;
                delete spec.is_own_bed;
            }
            // milestone = 234, mensch = 238, oemMonitor condition for show or hide the oem input fields, based on the make Id.
            const oemMonitor = ((((s.equipmentTypeId === 8 && s.planTypeId === 2) || (s.equipmentTypeId === 2 && s.planTypeId === 2) || (s.equipmentTypeId === 2 && s.planTypeId === 4)) && (s.fields.make_id && s.fields.make_id !== 238)) || (s.equipmentTypeId === 10 && s.planTypeId === 5 && (s.fields.make_id && s.fields.make_id === 238))) && s.makeList.includes(s.custom.make_id) &&
                s.fields.oem_monitor ? s.fields.oem_monitor === "Allow" : false;

            const params = {
                farm_uuid: farmId,
                equipment_type_id: s.equipmentTypeId,
                plan_type_id: s.planTypeId,
                category_id: s.categoryId > 0 ? s.categoryId : 0,
                subcategory_id: s.subcategoryId > 0 ? s.subcategoryId : 0,
                name: s.fields.name,
                make_name: s.custom.make_id,
                model_name: s.custom.model_id,
                vendor_name: s.custom.vendor_id,
                is_tare_truck: isTareTruck,
                rate_schedule_uuid: rateId,
                year: s.fields.year,
                serial_number: s.fields.serial_number,
                created_by: getUserId(),
                oem_monitor: oemMonitor,
                specification: spec,
                is_own_bed: isOwmBed
            };

            if (!this.isEditMode) this.props.dispatch(createEquipment(params, success));
            else {
                params.equipment_uuid = s.equipmentId;
                this.props.dispatch(editEquipment(params, success));
            }
        }
    }

    handleInputChange(name, value, event) {
        if (event.action !== "input-blur" && event.action !== "menu-close") {
            this.setState({ custom: { ...this.state.custom, [name]: value }, fields: { ...this.state.fields, [name]: '' } });
        }
    }

    onBlurMake(name, e) {
        const { value } = e.target;
        if (value.length > 0) {
            this.props.dispatch(equipmentModelList());
            this.setState({ custom: { ...this.state.custom, [name]: value } });
        }
    }

    getFieldsProps(item) {
        const inputs = this.state;

        if (item.input_type === 'list') {
            let options = [], selectProps = {};
            if (item.key_name === 'make_id') {
                options = this.props.equipmentMakeList && this.props.equipmentMakeList.length > 0 && this.props.equipmentMakeList.map(e => ({ value: e.equipment_make_id, label: e.equipment_make_name }));
                selectProps = {
                    onBlur: this.onBlurMake.bind(this, item.key_name),
                    noOptionsMessage: () => 'Create new make',
                    inputValue: inputs.custom.make_id,
                    onInputChange: this.handleInputChange.bind(this, item.key_name)
                };
            } else if (item.key_name === 'model_id') {
                options = this.props.equipmentModelList.map(e => ({ value: e.equipment_model_id, label: e.equipment_model_name }));
                selectProps = {
                    noOptionsMessage: () => 'Create new model',
                    inputValue: inputs.custom.model_id,
                    onInputChange: this.handleInputChange.bind(this, item.key_name)
                };
            } else if (item.key_name === 'year') {
                for (let i = 0; i <= 30; i++) {
                    let year = (new Date()).getFullYear() - i;
                    options.push({ key: i, value: year, label: year });
                }
            } else if (item.key_name === 'vendor_id') {
                options = this.props.equipmentVendorList.map(e => ({ value: e.equipment_vendor_id, label: e.equipment_vendor_name }));
                selectProps = {
                    onBlur: this.onBlurMake.bind(this, item.key_name),
                    noOptionsMessage: () => 'Create new vendor',
                    inputValue: inputs.custom.vendor_id,
                    onInputChange: this.handleInputChange.bind(this, item.key_name)
                };
            } else if (item.key_name === 'rate_schedule_uuid') {
                options = this.props.rateScheduleList.filter((e) => e.rate_schedule_applicable === 1).map(e => ({ label: e.rate_name, value: e.rate_uuid }));
            } else {
                options = item.values.map(e => ({ value: e, label: e }));
            }
            item = { ...item, values: options, selectProps };
        } else if (["capacity", "light_weight"].indexOf(item.key_name) >= 0) {
            item = {
                ...item, name: `${item.name} (${this.props.settings.weightShortName})`,
                min: this.unit.toRoundOfWeight(item.min), max: this.unit.toRoundOfWeight(item.max)
            };
        }

        return item;
    }

    componentWillUnmount() {
        this.props.dispatch(equipmentInfo());
    }

    render() {
        const inputs = this.state;
        const validation = this.submitted ? this.validator.validate(this.getStateValues()) : {};
        const isShowOemMonitor = (((inputs.equipmentTypeId === 8 && inputs.planTypeId === 2) || (inputs.equipmentTypeId === 2 && inputs.planTypeId === 2) || (inputs.equipmentTypeId === 2 && inputs.planTypeId === 4)) && (inputs.fields.make_id && inputs.fields.make_id !== 238)) || (inputs.equipmentTypeId === 10 && inputs.planTypeId === 5 && (inputs.fields.make_id && inputs.fields.make_id === 238));

        const isOemMake = this.state.oemMakeId.includes(this.state.fields.make_id) ? true : false;
        const updatedFields = this.props.fields && this.props.fields.length > 0 ? this.props.fields.map((item) => {
            return {
                ...item,
                required: (item.key_name === "model_id" && isOemMake) ? true : item.required,
            }
        }) : this.props.fields;

        const validateCategoryId = validation.hasOwnProperty('categoryId') && validation['categoryId'].isInvalid;

        return (
            <CardContainer className="form-container">
                <Card className="card-form">
                    <Card.Header>
                        <Card.Title>
                            <Heading5>
                                <TitleIcon className="fa fa-wrench" />{this.isEditMode ? 'Edit Equipment' : 'Add Equipment'}
                            </Heading5>
                            <i className="fa fa-times close-btn" aria-hidden="true" title="close"
                                onClick={this.props.onHide} />
                        </Card.Title>
                    </Card.Header>
                    <Card.Body>
                        <Row>
                            <Form.Cell>
                                <FormGroup>
                                    <Form.Label>Equipment Type</Form.Label>
                                    <Form.Select disabled={this.isEditMode} className="select-control-sm" placeholder="Select Equipment Type"
                                        value={inputs.equipmentTypeId} onChange={this.handleEquipmentType}
                                        options={this.props.equipmentTypeList.map(e => {
                                            return ({ value: e.id, label: e.name });
                                        })}
                                        sortType="asc" >
                                    </Form.Select>
                                </FormGroup>
                            </Form.Cell>

                            {(inputs.planTypeId !== null && (inputs.planTypeId === -1 || this.props.equipmentPlanList.length > 0)) ?
                                <Form.Cell>
                                    <FormGroup>
                                        <Form.Label>Plan Type</Form.Label>
                                        <Form.Select disabled={this.isEditMode} className="select-control-sm" placeholder="Select Plan Type"
                                            value={inputs.planTypeId} onChange={this.handlePlanType}
                                            options={this.props.equipmentPlanList.map(e => ({ value: e.plan_type_id, label: e.plan_type }))}
                                            sortType="asc" >
                                        </Form.Select>
                                    </FormGroup>
                                </Form.Cell> : null
                            }

                            {inputs.categoryId === -1 || this.props.categoryTypeList.length > 0 ?
                                <Form.Cell>
                                    <FormGroup>
                                        <Form.Label>Category<span className='text-danger'>*</span></Form.Label>
                                        <Form.Select disabled={this.isEditMode} className="select-control-sm" placeholder="Select Category Type"
                                            value={inputs.categoryId} onChange={this.handleCategory}
                                            options={this.props.categoryTypeList.map(e => ({ value: e.id, label: e.name }))}
                                            sortType="asc" >
                                        </Form.Select>
                                        {(validateCategoryId && this.state.categoryId === 0) ? <small className="form-text text-error">Category Required</small> : <></>}
                                    </FormGroup>
                                </Form.Cell> : <></>}

                            {(inputs.subcategoryId === -1 || this.props.subcategoryTypeList.length > 0) ?
                                <Form.Cell>
                                    <FormGroup>
                                        <Form.Label>Sub Category</Form.Label>
                                        <Form.Select disabled={this.isEditMode} className="select-control-sm" placeholder="Select Subcategory Type"
                                            value={inputs.subcategoryId} onChange={this.handleSubcategory}
                                            options={this.props.subcategoryTypeList.map(e => ({ value: e.id, label: e.name }))}
                                            sortType="asc" >
                                        </Form.Select>
                                    </FormGroup>
                                </Form.Cell> : <></>}

                            {updatedFields.map((item) => {
                                const validationExp = validation.hasOwnProperty(item.key_name) ? validation[item.key_name] : { isInvalid: false, message: '' };
                                let fieldValue = inputs.fields[item.key_name];
                                fieldValue = (((item.input_type === 'int' && fieldValue !== null) &&
                                    (fieldValue === 0 || typeof fieldValue === 'string'))) ? fieldValue.toString() : fieldValue;

                                if (item.input_type === 'text')
                                    return <EquipmentTextBox key={item.id} {...this.getFieldsProps(item)}
                                        onChange={this.handleChange} validation={validationExp} value={fieldValue} />;
                                else if (item.input_type === 'list')
                                    return <EquipmentDropdown key={item.id} {...this.getFieldsProps(item)}
                                        onChange={this.handleSelect} validation={validationExp} value={fieldValue} />;
                                else if (item.input_type === 'int')
                                    return <EquipmentInteger key={item.id} {...this.getFieldsProps(item)}
                                        onChange={this.handleChange} validation={validationExp} value={fieldValue} />;
                                else if (item.input_type === 'boolean')
                                    return <EquipmentBoolean key={item.id} {...this.getFieldsProps(item)}
                                        onChange={this.handleChecked} validation={validationExp} value={fieldValue} />;
                                else if (item.input_type === 'date')
                                    return <EquipmentDate key={item.id} {...this.getFieldsProps(item)}
                                        validation={validationExp} onChange={this.handleChange} />;
                                return item;
                            })}
                            {
                                (isShowOemMonitor && inputs.custom.make_id !== 0 && inputs.makeList.includes(inputs.custom.make_id)) ? <EquipmentDropdown  {...inputs.oem_monitor}
                                    onChange={this.handleSelect} validation={{ isInvalid: false, message: '' }} value={inputs.fields["oem_monitor"]} /> : null
                            }
                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <Button type="button" variant="primary" size="sm" className="float-right ml-3" onClick={() => this.saveEquipment(updatedFields)}>
                            <Icon className="fa fa-floppy-o"></Icon> Save
                        </Button>
                        <Button type="button" variant="danger" className="float-right" size="sm"
                            onClick={this.props.onHide}>
                            <Icon className="fa fa-times-circle"></Icon> Cancel
                        </Button>
                    </Card.Footer>
                </Card>
            </CardContainer>
        )
    }
}

const mapStateToProps = state => ({
    equipmentTypeList: state.equipment.equipmentTypeList,
    categoryTypeList: state.equipment.categoryTypeList,
    subcategoryTypeList: state.equipment.subcategoryTypeList,
    equipmentPlanList: state.equipment.planTypeList,
    equipmentInfo: state.equipment.equipmentInfo,
    equipmentMakeList: state.equipment.equipmentMakeList,
    equipmentModelList: state.equipment.equipmentModelList,
    equipmentVendorList: state.equipment.equipmentVendorList,
    fields: [
        ...state.equipment.fields.equipmentType,
        ...state.equipment.fields.category,
        ...state.equipment.fields.subcategory
    ].sort((a, b) => a.display_order - b.display_order),
    settings: state.user.settings,
    makeList: state.oem.makeList.payload,
    rateScheduleList: state.rateSchedule.rateScheduleList
});

export default connect(mapStateToProps)(EquipmentForm);
